import styled from "../_snowpack/pkg/@emotion/styled.js";
import React, {useEffect, useRef, useState} from "../_snowpack/pkg/react.js";
import {getFromLocalStore, getUrl} from "../common/universal.js";
import {Routes} from "../typings/routes.js";
import {useIframeListener} from "../common/hooks.js";
import {callIframeMethod} from "../common/utils.js";
import Loader from "./loader.js";
const timeout = 5e3;
export default function ErpaViewer(props) {
  const {
    editorConfig,
    outsideTexturePath,
    insideTexturePath,
    productSlug,
    article,
    alternative_erpa_standard: alternativeStandard,
    extra_erpa_parameters = "",
    product_page,
    ...rest
  } = props;
  const standard = alternativeStandard ? alternativeStandard : editorConfig.standard;
  const fallback = outsideTexturePath ? getUrl(Routes.getPrintThumbnail, {
    path: outsideTexturePath
  }) : product_page.content.product[0].cart_image?.filename;
  const iframeSrc = getUrl(Routes.editorGetFrame, {}, {
    query: {
      editorConfig: JSON.stringify(editorConfig),
      standard,
      outsideTexturePath,
      insideTexturePath,
      productSlug,
      articleId: article.id
    }
  }) + `&${extra_erpa_parameters}`;
  const [previewSrc, setPreviewSrc] = useState(getFromLocalStore(iframeSrc));
  const [loading, setLoading] = useState(true);
  const iframeRef = useRef(null);
  const fiveSecondsPassedRef = useRef(false);
  const saveScreenshot = async () => {
    const image = await callIframeMethod(iframeRef, "getScreenshot");
    if (!image) {
      return;
    }
    if (!fiveSecondsPassedRef.current)
      setPreviewSrc(image);
    localStorage.setItem(iframeSrc, image);
  };
  useIframeListener(() => saveScreenshot, iframeSrc);
  const onIframeLoad = () => {
    setLoading(false);
    saveScreenshot();
  };
  const onLoad = () => {
    setLoading(false);
  };
  const onError = () => {
    setLoading(false);
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      fiveSecondsPassedRef.current = true;
      if (!fallback)
        return;
      if (previewSrc)
        return;
      setPreviewSrc(fallback);
    }, timeout);
    return () => clearTimeout(timer);
  }, [previewSrc]);
  return /* @__PURE__ */ React.createElement(Container, {
    ...rest
  }, loading && /* @__PURE__ */ React.createElement(LoaderContainer, null, /* @__PURE__ */ React.createElement(Loader, null)), previewSrc ? /* @__PURE__ */ React.createElement(Image, {
    src: previewSrc,
    onLoad,
    onError,
    loading: "lazy"
  }) : /* @__PURE__ */ React.createElement(Iframe, {
    src: iframeSrc,
    ref: iframeRef,
    onLoad: onIframeLoad,
    onError,
    width: "300px",
    height: "300px",
    isLoading: loading,
    loading: "lazy"
  }));
}
const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 40px;
  overflow: hidden;
  pointer-events: none;
  padding: 0;
  height: auto;

  ${({backgroundColor}) => backgroundColor && `background: ${backgroundColor}70;`}
`;
const Image = styled.img`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  overflow: hidden;
  z-index: 0;
  width: 100%;
  height: 100%;
  object-fit: scale-down;
`;
const Iframe = styled.iframe`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;

  ${({isLoading}) => isLoading && `visibility: hidden;`}
`;
const LoaderContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 25px;
`;
